export const PLACEHOLDER_CHARS = ['#', '\\', '~', '^', '@'];

export function getRandomItems(arr, n) {
    if (!arr) return arr;
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr.slice(0, n);
}

export function shiftCards(cardsArr, index0, index1) {
    const newCards = [...cardsArr];
    const card = newCards.splice(index0, 1)[0];
    newCards.splice(Math.max(0, Math.min(newCards.length, index1)), 0, card);
    return newCards;
}

export function fillPlaceholdersForCard(card, placeholderMap) {
    if (!card.placeholders || card.placeholders.length === 0 || !placeholderMap) {
        return;
    }

    card.placeholders.forEach(holder => {
        if (holder.w === "") {
            let check = placeholderMap[holder.p];
            if (!check) {
                holder.w = holder.p;
                holder.t = holder.p;
                return;
            }

            if (check.type === "randombunch") {
                const reactants = check.reactants;
                if (!reactants || reactants.length === 0) return;
                const randomPlaceholder = reactants[Math.floor(Math.random() * reactants.length)];
                check = placeholderMap[randomPlaceholder];
                if (!check) return;
            }
            if (check.type === "name") {
                holder.w = check.wordlist[0] || "";
                holder.t = holder.w;
            } else {
                const item = check.wordlist ? check.wordlist[0] : null;
                holder.w = item ? (item.p || "") : "";
                holder.t = item ? (item.t || "") : "";
            }
            if (check.wordlist && Array.isArray(check.wordlist)) {
                check.wordlist = shiftCards(check.wordlist, 0, check.wordlist.length);
            }
        }
    });
}

export function scanCardPlaceholders(cards) {
    const placeholders = [];
    cards.forEach(card => {
        if (!card.placeholders) {
            card.placeholders = [];
        }
        PLACEHOLDER_CHARS.forEach(char => {
            for (let i = 0; i + 1 < card.prompt.length; i++) {
                if (char === card.prompt.charAt(i)) {
                    const numpart = card.prompt.charAt(++i);
                    if (numpart >= '0' && numpart <= '9') {
                        const key = char + numpart;
                        placeholders.push(key);
                        card.placeholders.push({ p: key, w: "", t: "" });
                    }
                }
            }
        });
    });
    return placeholders;
}

export function buildFilteredPlaceholderMap(codes, placeholderKeys, numPlaceholders) {
    const placeholderSet = new Set(placeholderKeys);

    // Expand placeholderSet to include reactants for randombunch types
    let added = true;
    while (added) {
        added = false;
        for (const key of placeholderSet) {
            const entry = codes[key];
            if (entry && entry.type === "randombunch" && entry.reactants) {
                for (const reactant of entry.reactants) {
                    if (!placeholderSet.has(reactant)) {
                        placeholderSet.add(reactant);
                        added = true;
                    }
                }
            }
        }
    }

    return Object.fromEntries(
        Object.entries(codes)
            .filter(([key]) => placeholderSet.has(key))
            .map(([k, v]) => [k, { ...v, wordlist: getRandomItems(v.wordlist, numPlaceholders) }])
    );
}

export function resolveCardDisplayText(card) {
    let prompt = card.prompt;
    let translation = card.translation;
    if (card.placeholders && card.placeholders.length > 0) {
        card.placeholders.forEach(p => {
            prompt = prompt.replace(p.p, p.w);
            translation = translation.replace(p.p, p.t);
        });
    }
    return { prompt, translation };
}

export async function loadLanguagePlaceholderMap(languageId, placeholderKeys, numPlaceholders) {
    const module = await import(`../assets/wordlists/placeholders/${languageId}.json`);
    const codes = (module.default || module).codes;
    return buildFilteredPlaceholderMap(codes, placeholderKeys, numPlaceholders);
}
